import type { FigmaIconProps } from './types';

interface IconFigmaNotificationsProps extends FigmaIconProps {
  withDot?: boolean;
}

export const IconFigmaNotifications = ({
  size = 28,
  color = 'currentColor',
  withDot = false
}: IconFigmaNotificationsProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.5556 21.5007C12.7019 21.754 12.9123 21.9644 13.1657 22.1107C13.419 22.257 13.7064 22.334 13.999 22.334C14.2915 22.334 14.5789 22.257 14.8323 22.1107C15.0857 21.9644 15.2961 21.754 15.4424 21.5007M6.71773 16.7719C6.60886 16.8913 6.53702 17.0397 6.51094 17.1991C6.48485 17.3585 6.50566 17.522 6.57081 17.6698C6.63597 17.8176 6.74268 17.9433 6.87795 18.0316C7.01322 18.1199 7.17122 18.1669 7.33274 18.1671H20.6664C20.8279 18.1671 20.9859 18.1202 21.1212 18.0321C21.2566 17.944 21.3634 17.8185 21.4288 17.6708C21.4941 17.5231 21.5151 17.3596 21.4892 17.2001C21.4634 17.0407 21.3917 16.8922 21.283 16.7728C20.1747 15.6302 18.9996 14.4159 18.9996 10.6664C18.9996 9.34023 18.4729 8.06835 17.5352 7.13059C16.5975 6.19283 15.3257 5.666 13.9995 5.666C12.6734 5.666 11.4016 6.19283 10.4639 7.13059C9.52624 8.06835 8.99944 9.34023 8.99944 10.6664C8.99944 14.4159 7.82359 15.6302 6.71773 16.7719Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    {withDot && (
      <circle
        cx="22"
        cy="6"
        r="3.5"
        fill="var(--color-accent-primary-soft)"
        stroke="var(--color-accent-secondary)"
      />
    )}
  </svg>
);
